import { MouseEvent, useCallback, useState } from "react";

export const usePopupState = <ElementType = HTMLButtonElement>() => {
  const [anchorEl, setAnchorEl] = useState<ElementType | null>(null);

  const handleOpen = useCallback((event: MouseEvent<ElementType>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const isOpen = Boolean(anchorEl);

  return {
    anchorEl,
    handleOpen,
    handleClose,
    isOpen
  };
};
